import React from "react";
import { createRoot } from "react-dom/client";

import "./i18n";
import "./index.css";
import App from "./App";

const domNode = document.getElementById("root");
const root = createRoot(domNode!);

root.render(<App />);
